module.exports = __webpack_public_path__ + "static/voyayge-logo-beta-7d4bbef2bff3d6a4db4aebe51364898d.png";